import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  item: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  itemActive: {
    color: theme.palette.secondary.dark
  },
  itemNotActive: {
    color: theme.palette.text.hint
  },
  itemHorseName: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  itemHorseNameTitle: {
    fontFamily: "SuisseIntlMedium",
    fontSize: 13,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 16
    }
  },
  itemIcon: {
    fontSize: 14,
    marginRight: 10,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 15
    }
  },
  checkIcon: {
    fontSize: 14,
    color: theme.palette.secondary.dark,
    marginRight: 10,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 15
    }
  },
  itemHorseDetailsGender: {
    fontWeight: "bold"
  },
  itemHorseTrainerIcon: {
    marginLeft: 10,
    marginRight: 0
  },
  itemHorseDetails: {
    display: "flex",
    flexDirection: "column",
    fontSize: 12,
    textAlign: "right",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 14
    }
  },
  itemHorseDetailsTrainer: {
    flexDirection: "row",
    alignItems: "center"
  }
}));
